import { render, staticRenderFns } from "./header-devops.vue?vue&type=template&id=5315d4b8&scoped=true&"
import script from "./header-devops.vue?vue&type=script&lang=js&"
export * from "./header-devops.vue?vue&type=script&lang=js&"
import style0 from "./header-devops.vue?vue&type=style&index=0&id=5315d4b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5315d4b8",
  null
  
)

export default component.exports